<app-default-card
  *ngIf="shouldShowFeedbackCard"
  [title]="'Rückfrage'"
  [info]="
    'Es gibt eine offene Rückfrage zu dem Vorgang. Bitte beantworten Sie diese, passen ggf. Antragsdaten an und reichen den Vorgang erneut ein.'
  ">
  <div class="message-info">
    <p>
      <strong>Rückfrage vom Netzbetreiber:</strong>
      <br />
      {{ networkOperatorFeedbackComment }}
    </p>
  </div>
  <form-row *ngIf="!isEditor && canEditInstallerComment; else editorFeedback" [formGroup]="formGroup">
    <mat-form-field appearance="outline" fxFlex="90">
      <mat-label>Kommentar Kunde/Installateur</mat-label>
      <textarea matInput type="text" rows="5" formControlName="installerFeedbackComment"></textarea>
    </mat-form-field>
  </form-row>

  <ng-template #editorFeedback>
    <strong>Antwort:</strong>
    <p>
      {{ installerFeedbackComment }}
    </p>
  </ng-template>
</app-default-card>
